import React from 'react';
import CollapseButton from './CollapseButton';
import ListStatus from './ListStatus';
import SchemaValues from './SchemaValues';
import PropTypes from 'prop-types';

const RequirementWidgetFactory = ({ name, data, events, schema }) => {
  switch (name) {
    case 'ListStatus':
      return (
        <ListStatus
          data-cy={'list-status'}
          statuses={data}
          expanded={events[`${name}_isCollapse`]}
        />
      );
    case 'ListStatus_collapseButton':
      return <CollapseButton data-cy={'collapse-button'} onClick={events[name]?.onClick} />;
    case 'SchemaValues':
      return <SchemaValues data-cy={'schema-values'} data={data} />;
    case 'SchemaLabelValues':
      return <SchemaValues data-cy={'schema-label-values'} data={data} schema={schema} />;
    default:
      return <></>;
  }
};

RequirementWidgetFactory.propTypes = {
  name: PropTypes.string,
  data: PropTypes.object,
  events: PropTypes.object,
  schema: PropTypes.object,
};

RequirementWidgetFactory.defaultProps = {
  name: '',
  data: {},
  events: null,
  schema: null,
};

export default RequirementWidgetFactory;
